
export const formatDecimal = (input) => {
  return input;
}
